import type { IAccountUser } from './AccountUser.interface';
import Address from '../address/Address';
import AccountUserLicenses from './AccountUserLicenses';
import { PersonalTitle } from '../global/PersonalTitle.enum';

export default class AccountUser implements IAccountUser {
  avatar: string;
  title: PersonalTitle;
  firstName: string;
  lastName: string;
  eMail: string;
  prefix: string;
  phone: string;
  fixedPrefix: string;
  fixedPhone: string;
  location: string;
  address: Address;
  licenses: AccountUserLicenses;

  static build = (data: IAccountUser) => new AccountUser(data);
  static blank = () => new AccountUser();

  /**
   * Constructor
   * @param {IAccountUser} data
   */
  constructor(data?: IAccountUser) {
    this.avatar = data?.avatar || undefined;
    this.title = data?.title
      ? PersonalTitle.of(data?.title?.name || data?.title?.toString())
      : undefined;
    this.firstName = data?.firstName || undefined;
    this.lastName = data?.lastName || undefined;
    this.eMail = data?.eMail || undefined;
    this.prefix = data?.prefix || undefined;
    this.phone = data?.phone || undefined;
    this.fixedPrefix = data?.fixedPrefix || undefined;
    this.fixedPhone = data?.fixedPhone || undefined;
    this.location = data?.location || undefined;
    this.address = new Address(data?.address);
    this.licenses = new AccountUserLicenses(data?.licenses);
  }
}
